import React, { useEffect, useState } from 'react';

import { notification } from 'src/components/Notification';
import { QuestionTextDefaultProps, QuestionTextPropTypes } from 'src/components/JobDatasheet/propTypes';
import { EiqInput, EiqTextarea } from 'eiq-storybook';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionText = ({
  errors,
  flash,
  isRectifiedQuestion,
  onChange,
  question,
  readonly,
  value,
  disableChange,
  questionType
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const [currentValue, setCurrentValue] = useState(value ? value[selectedValueKey] : '');

  useEffect(() => {
    setCurrentValue(value ? value[selectedValueKey] : '');
  }, [value?.value, value?.rectifiedValue]);

  const { isTextarea } = question.textSettings || {
    isTextarea: false,
  };

  const onInputChange = e => {
    if (!readonly) {
      setCurrentValue(e.target.value);
    } else {
      notification.error(readonly);
    }
  };
  const onBlur = () => {
    if (value?.value === currentValue) {
      return;
    }

    const returnObject = {
      ...value,
      type: questionType || 'text'
    };

    returnObject[selectedValueKey] = currentValue?.trim();

    onChange(returnObject);
  };

  return (
    <s.QuestionTextWrapper>
    { isTextarea ? 
      <EiqTextarea 
        rows="3" 
        onBlur={() => !readonly && onBlur()}
        onChange={!disableChange && onInputChange}
        value={currentValue || ''}
        errorMessage={(errors || []).join(' & ')}
        wrapperClassName={`${readonly ? 'eiqTextareaReadonly' : ''} eiqTextarea`}
        id={`textarea-${question.id}`}
        readOnly={readonly}
      /> :
      <EiqInput 
        type="text"
        onBlur={() => !readonly && onBlur()}
        onChange={!disableChange && onInputChange}
        value={currentValue || ''}
        errorMessage={(errors || []).join(' & ')}
        wrapperClassName={`${readonly ? 'eiqInputReadonly' : ''} eiqInput`}
        id={`input-${question.id}`}
        readOnly={readonly}
      />
    }
    </s.QuestionTextWrapper>
  );
};

QuestionText.propTypes = QuestionTextPropTypes;
QuestionText.defaultProps = QuestionTextDefaultProps;
